import { render, staticRenderFns } from "./lo-dialog.vue?vue&type=template&id=16fd5c99&scoped=true"
import script from "./lo-dialog.vue?vue&type=script&lang=js"
export * from "./lo-dialog.vue?vue&type=script&lang=js"
import style0 from "./lo-dialog.vue?vue&type=style&index=0&id=16fd5c99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd5c99",
  null
  
)

export default component.exports